import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jweb-mpcssservlet',
	templateUrl:'./JWebMPCSSServletPluginCompPage.html',
	styles: [],
	styleUrls:['./JWebMPCSSServletPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JWebMPCSSServletPluginCompPage
{
	mdContent_1042 = `\`\`\`java
import com.jwebmp.vertx.JWebMPCSSServlet;
\`\`\``;
	mdContent_1043 = `\`\`\`java
JWebMPCSSServlet()
\`\`\``;
	mdContent_1044 = `\`\`\`java
// All CSS generated by page components is served at:
// GET /jwcss
// The response Content-Type is text/css
\`\`\``;
}
